export default __webpack_public_path__ + "static/tiles-3-0baebc5c963519ff0a30b6cb4e48b8c7.webp";